import { FileText } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

interface CaseDetailsCardProps {
  incidentType: string
  incidentDate: string
  airlineCode: string
  customTitle: string
  summaryTitle?: string
  onChangeIncidentType: (value: string) => void
  onChangeIncidentDate: (value: string) => void
  onChangeAirlineCode: (value: string) => void
  onChangeCustomTitle: (value: string) => void
}

export function CaseDetailsCard({
  incidentType,
  incidentDate,
  airlineCode,
  customTitle,
  summaryTitle,
  onChangeIncidentType,
  onChangeIncidentDate,
  onChangeAirlineCode,
  onChangeCustomTitle,
}: CaseDetailsCardProps) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <h2 className="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">
        <FileText className="h-5 w-5 text-slate-400" />
        Falldetails
      </h2>
      <div className="space-y-4">
        {/* Custom Title */}
        <div>
          <Label htmlFor="custom_title" className="text-sm text-slate-600">
            Titel
          </Label>
          <Input
            id="custom_title"
            value={customTitle}
            onChange={(e) => onChangeCustomTitle(e.target.value)}
            placeholder={summaryTitle || 'z.B. Müller // Lufthansa'}
            className="mt-1"
          />
          <p className="text-xs text-slate-500 mt-1">
            Leer lassen für automatischen Titel basierend auf Mandant und Beklagter.
          </p>
        </div>

        {/* Incident Details */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <Label htmlFor="incident_type" className="text-sm text-slate-600">
              Vorfallart
            </Label>
            <Select value={incidentType} onValueChange={onChangeIncidentType}>
              <SelectTrigger id="incident_type" className="mt-1">
                <SelectValue placeholder="Typ wählen" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="delay">Verspätung</SelectItem>
                <SelectItem value="cancel">Annullierung</SelectItem>
                <SelectItem value="denied_boarding">Nichtbeförderung</SelectItem>
                <SelectItem value="other">Sonstiges</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label htmlFor="incident_date" className="text-sm text-slate-600">
              Vorfalldatum
            </Label>
            <Input
              id="incident_date"
              type="date"
              value={incidentDate}
              onChange={(e) => onChangeIncidentDate(e.target.value)}
              className="mt-1"
            />
          </div>
          <div>
            <Label htmlFor="airline_code" className="text-sm text-slate-600">
              Airline-Code
            </Label>
            <Input
              id="airline_code"
              value={airlineCode}
              onChange={(e) => onChangeAirlineCode(e.target.value.toUpperCase())}
              placeholder="LH"
              maxLength={3}
              className="mt-1 font-mono uppercase"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
